<script setup lang="ts">
import { ref } from 'vue';
import { search } from 'fast-fuzzy';
import type { Activity } from '../models/Activity';
import AppDropdownSelect, { DropdownAppearance } from './AppDropdownSelect.vue';

const props = withDefaults(defineProps<{
	appearance?: DropdownAppearance;
	canDeselect?: boolean;
	options: Activity[];
}>(), {
	appearance: 'regular',
	canDeselect: false,
});

const selectRef = ref();

const focus = () => {
	selectRef.value.focus();
};

const getFilteredOptions = (query: string, options: Activity[]) => {
	if (!query) return props.options;

	return search(
		query,
		options,
		{
			keySelector: (option) => option.name,
			threshold: 0.7,
		},
	);
};

defineExpose({
	focus,
});
</script>

<template>
	<AppDropdownSelect
		ref="selectRef"
		v-bind="$attrs"
		:options="options"
		:appearance="appearance"
		:can-deselect="canDeselect"
		:search-function="getFilteredOptions"
	>
		<template #optionAttributes="{ attributes }">
			<div
				:class="{
					'w-full px-4 left-0 top-0 text-center h-7 pointer-events-none leading-snug flex justify-center flex-col': appearance === 'small' || appearance === 'smallRounded',
					'text-center flex items-center h-full left-0 top-0 pointer-events-none bg-transparent leading-snug max-w-[85%]': appearance === 'regular',
				}"
			>
				<p
					:class="{
						'py-1 px-4 rounded-full mx-auto whitespace-nowrap': appearance === 'small' || appearance === 'smallRounded',
						truncate: appearance === 'regular',
					}"
				>
					{{ attributes.name }}
				</p>
			</div>
		</template>
	</AppDropdownSelect>
</template>
